module.exports = __webpack_public_path__ + "img/aquarius.aa73dc00.svg";